<script>
import { widgetActions } from '@state/helpers'
import { mapState } from 'vuex'
import deepLink from '@mixins/deeplink'

const IMAGE_ICON_ANDROID = 'arrow_back_android';
const IMAGE_ICON_IOS = 'arrow_back_ios';

export default {
  name: 'ZendeskArticle',
  mixins: [deepLink()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('widgets', {
      userOS: state => state.common.user.os,
    }),
    backButtonText() {
      return this.userOS !== 'Android' ? this.$t('WIDGETS.ZENDESK_ARTICLE.RETURN_BUTTON') : '';
    }
  },
  methods: {
    ...widgetActions,
    getImgUrl() {
      const image = require.context('@assets/images/', false, /\.png$/);
      const name = this.userOS === 'Android' ? IMAGE_ICON_ANDROID : IMAGE_ICON_IOS;
      return image(`./${name}.png`);
    },
    redirectToWhatsapp() {
      this.thirdPartyDeepLink(this.componentData.whatsappDeepLink);
    }
  },
}
</script>

<template>
  <div
    :class="$style.zAContainer"
    :id="`${this.$options.name}-container`"
  >
    <a
      v-if="componentData.whatsappDeepLink"
      :class="$style.zAContainer"
      @click="redirectToWhatsapp()">
      <img
        :class="$style.zAContainer__back"
        :src="getImgUrl()"
        :alt="backButtonText">
      <span :class="$style.zAContainer__label">{{ backButtonText }}</span>
    </a>
    <h1
      :class="$style.zAContainer__header"
    >{{ componentData.title || componentData.name }}</h1>
    <div
      :class="$style.zAContainer__content"
      v-html="componentData.body"/>
    <div :class="$style.zAContainer__divider"/>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';
</style>
